import { render, staticRenderFns } from "./ViewLoan.vue?vue&type=template&id=0aecc83c&"
import script from "./ViewLoan.vue?vue&type=script&lang=js&"
export * from "./ViewLoan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports